// extracted by mini-css-extract-plugin
module.exports = {"error-property-info":"error-info_error-property-info__HIs7I"};